import { ACTIVATE_CARD_ISSUING_FORM_FIELDS } from 'consts';

export const formatActivateCardDateToApi = values => {
  return {
    card_number: values[ACTIVATE_CARD_ISSUING_FORM_FIELDS.number]?.replace(/\s/g, ''),
    pin: values[ACTIVATE_CARD_ISSUING_FORM_FIELDS.pin]
  };
};
